<template>
  <div class="story">
    <b-container class="container-lg mt-top text-left prl-outside">
        <b-row class="p-0 m-0">
            <b-col cols="12" class="mb-3">
                <div class="ml-4 home-pics top-pic cursorp" style="position:relative;" v-if="story.pictures" title="großes Bild zeigen" @click="openPicture(story.pictures, 0)">
                    <img :src="require(`@/assets/img/GeraInside/${typeof story.pictures[0] === 'object' ? story.pictures[0].image : story.pictures[0]}`)" class="w-100 mt-3 mb-4">
                    
                    <p v-if="typeof story.pictures[0] === 'object' && story.pictures[0].caption" class="top-caption-text" v-html="story.pictures[0].caption"></p>
                </div>
                
                <div class="info-line ml-2" style="height:auto;">
                    <div class="pic" style="border-radius:5px;overflow:hidden;width:100px;"><img :src="require(`@/assets/img/team/${story.userPicture}`)"/></div>
                    <div class="text">{{story.user}} {{$t('on')}} {{story.date}}</div>
                </div>
                <h3 class="fw800 mt60">{{story.title}}</h3>
                <p class="text-left mt-3" v-html="story.titleText"></p>
            </b-col>

            <b-col cols="12" class="mb-5">
                <div v-for="(pic, key) in story.pictures" :key="key" class="pic-div mb-4 cursorp" style="position:relative;" :class="(key==0)?'first-pic':''" title="großes Bild zeigen" @click="openPicture(story.pictures, key)">
                    <img :src="require(`@/assets/img/GeraInside/${typeof pic === 'object' ? pic.image : pic}`)" :class="(key==0)?'first-pic':''"/>
                    
                    <p v-if="typeof pic === 'object' && pic.caption" class="caption-text" v-html="pic.caption"></p>
                </div>
            </b-col>
        </b-row>
    </b-container>

    <div class="big-text">GERA Inside - Geschichte</div>
    
    <app-modal-galery v-if="overlayVisible"
        picFolder="GeraInside/"
        :pictures="formattedPicturesForGallery"
        :startPictureIndex="selPicIndex"
        @closePicGalery="overlayVisible=false"
    />
  </div>
</template>

<script>
import appModalGalery from '@/components/ModalGalery.vue';

export default {
  name: 'story',
  components: {
    appModalGalery
  },
  data () {
    return {
        story: this.$store.state.story,
        overlayVisible: false,
        pictures: null,
        selPicIndex: 0
    }
  },
  methods: {
    openPicture(pict, key){
        this.pictures = pict;
        this.selPicIndex = key;
        this.overlayVisible = true;
    },
    hidePicture(){
        this.overlayVisible = false;
        this.pictures = null;
        this.selPicIndex = 0;
    }
  },
  computed: {
    // Wandelt das Array für die Galerie um, damit diese nur Strings bekommt
    formattedPicturesForGallery() {
        if (!this.pictures) return null;
        return this.pictures.map(p => typeof p === 'object' ? p.image : p);
    }
  },
  created () {
    if (!this.$store.state.story) this.$router.push('/Gerainside')
  }
}
</script>

<style scoped>
.top-pic {
    display: block;
}
.first-pic {
    display: none;
}
.info-line .pic {
    width: 40px !important;
    height: auto;
}
.info-line .pic img {
    width: 40px !important;
    height: auto;
}

.pic-div {
  float: left;
  /* Höhe auf auto, damit der Container wachsen kann, wenn Text da ist */
  height: auto; 
  width: auto;
  overflow: hidden;
  margin-right: 0.5rem;
  margin-bottom: 20px; /* Abstand zur nächsten Zeile */
}

.pic-div img {
    /* 'object-fit: contain' verhindert das Abschneiden */
    object-fit: contain;
    width: auto;
    /* Das Bild behält immer diese feste Höhe */
    height: 300px; 
    display: block;
}

/* Styles für die Bildunterschriften */
.caption-text {
  font-size: 0.8rem;
  line-height: 1.2;
  margin-top: 8px; /* Abstand zum Bild */
  color: #333;
  font-weight: 600;
  max-width: 280px;
  word-wrap: break-word;
  text-align: left;
}

.top-caption-text {
  font-size: 1rem;
  font-style: italic;
  color: #666;
  margin-top: 5px;
  margin-bottom: 25px;
  text-align: left;
}

@media only screen and (max-width: 992px) {
    .pic-div {
        margin-right: 0;
        height: auto;
    }
}

@media only screen and (max-width: 910px) {
    .top-pic {
        display: none !important;
    }
    .first-pic {
        display: block;
        width: 100% !important;
        height: auto !important;
    }
    .pic-div {
        float: none;
        width: 100%;
    }
    .pic-div img {
        height: auto; /* Auf Mobilgeräten volle Breite, Höhe flexibel */
        width: 100%;
        max-height: none;
    }
}
</style>

<i18n>
    {
        "de": {
            "on": "am"
        },
        "en": {
            "on": "on"
        }
    }
</i18n>